<template>
  <div class="device-edit">
    <my-header title="更新设备信息" back-path="/user/device/list">
    </my-header>
    <div class="container">
      <div class="content">
        <div class="item">
          <div class="title">设备名称</div>
          <div>
            <el-input v-if="editName" class="input-new-tag width-160" ref="deviceName" @change="handleNameConfirm" v-model="deviceName"></el-input>
            <span class="value pointer" v-text="deviceName" v-else @click="editName=true;$nextTick(()=>$refs.deviceName.focus())"></span>
          </div>
        </div>
        <div class="item">
          <div class="title">设备别名</div>
          <div>
            <el-tag
                    :key="tag"
                    v-for="tag in dynamicTags"
                    closable
                    :disable-transitions="false"
                    @close="handleClose(tag)">
              {{tag}}
            </el-tag>
            <el-input
                    class="input-new-tag"
                    v-if="inputVisible"
                    v-model="inputValue"
                    ref="saveTagInput"
                    @keyup.enter.native="handleInputConfirm"
                    @blur="handleInputConfirm"
            >
            </el-input>
            <template v-else>
              <el-button class="button-new-tag" v-if="dynamicTags.length < 5" size="small" @click="showInput">+ 新增别名</el-button>
            </template>
          </div>
        </div>
      </div>
      <div class="remark">
        <img src="@/assets/images/home/zy.png"/>
        <span>设备别名可用于微信语音控制，提高语音控制的识别率。</span>
      </div>
    </div>
  </div>
</template>

<script>
import MyHeader from '@/components/HeaderTitle'
import comm from '@/assets/lib/comm'
import device from '@/model/device'
import { Message } from 'element-ui'

export default {
  name: 'DeviceEdit',
  props: {
    device: {}
  },
  data () {
    return {
      dynamicTags: [],
      editName: false,
      inputVisible: false,
      inputValue: '',
      saving: false,
      deviceName: ''
    }
  },
  components: {
    MyHeader
  },
  created () {
    if (!this.device) {
      // 返回上一步
      this.$router.push('/user/device/list')
    } else {
      this.dynamicTags = this.device && this.device.alias ? this.device.alias.split(',') : []
      this.deviceName = this.device.name
    }
  },
  methods: {
    handleClose (tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1)
      this.save()
    },
    showInput () {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    handleNameConfirm () {
      if (this.deviceName) {
        this.editName = false
        this.save()
      } else {
        Message.warning('设备名称不能为空')
      }
    },
    handleInputConfirm () {
      let inputValue = this.inputValue
      if (inputValue && !this.dynamicTags.includes(inputValue)) {
        this.dynamicTags.push(inputValue)
        this.save()
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    async save () {
      if (!this.saving) {
        this.saving = true
      } else {
        return
      }
      const loading = comm.showLoading()
      try {
        const saveObj = { tp: this.device.type, id: this.device.id, alias: this.dynamicTags.join(',') }
        if (this.device.type === 'light') {
          saveObj.devicenodename = this.deviceName
        } else {
          saveObj.name = this.deviceName
        }
        await device.updateDeviceInfo(saveObj)
        // 同步本地缓存
        this.$store.commit('UPDATE_DEVICE_NAME', saveObj)
      } catch (e) {
        Message.error(e.message)
      } finally {
        comm.closeLoading(loading)
        this.saving = false
      }
    }
  }
}
</script>
<style lang="less">
.device-edit {
  .el-tag + .el-tag {
    margin-left: 10px;
  }

  .el-tag {
    background-color: white;
    border: 1px solid rgba(158, 230, 187, 1);
  }

  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 32px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .input-new-tag {
    width: 150px;
    /*padding: 5px 0px;*/
    margin-left: 10px;
    vertical-align: bottom;
  }

  .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
}
</style>
<style scoped lang="less">
.device-edit {
  height: 100%;
  display: flex;
  flex-direction: column;
  .container {
    flex: 1;
    position: relative;
    padding: 65px 20px 20px 20px;
    overflow-y: auto;
    & .content {
      border-radius: 4px;
      background-color: white;
      padding: 0px 20px;
      & .item:first-child {
        border: 0px;
      }
      & .item {
        padding: 15px 0px;
        height: 62px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-top: 1px solid rgba(220, 220, 220, .5);
        & .width-160 {
          width: 160px;
        }
        & .title {
          font-size: 17px;
          font-weight: 400;
          color: rgba(34, 34, 34, 1);
        }
        & .value {
          color: #636363;
          font-weight: 400;
          font-size: 15px;
        }
      }
    }
    & .remark {
      font-size: 15px;
      font-weight: 400;
      color: rgba(198, 198, 198, 1);
      margin-top: 12px;
      display: flex;
      align-items: flex-start;
      & img {
        width: 18px;
        margin-right: 8px;
        vertical-align: middle;
      }
    }
  }
}
</style>
